import { useState, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { ClipboardList, Star, ThumbsUp, ArrowLeft, MapPin } from 'lucide-react'
import { Bar, BarChart, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { useDocumentTitle } from '@/shared/hooks/use-document-title'

// ── Tipos ────────────────────────────────────────────────────────────────────

interface RespuestaEncuesta {
  nombre: string
  especialidad: string
  ciudad: string
  sat_organizacion: number
  sat_escena: number
  sat_locacion: number
  sat_alimentacion: number
  cal_conferencia_ia: number
  cal_conferencia_yepez: number
  val_comunicacion_yepez: number
  cal_qa: number
  recomendaria: boolean
  comentarios: string
}

// ── Data (BD producción: eventos_respuestaencuesta, sin registros de prueba) ──

const ENCUESTAS: RespuestaEncuesta[] = [
  { nombre: 'Susana Margoth López Chipantasi', especialidad: 'Gastroenterología', ciudad: 'Quito', sat_organizacion: 5, sat_escena: 5, sat_locacion: 5, sat_alimentacion: 5, cal_conferencia_ia: 5, cal_conferencia_yepez: 5, val_comunicacion_yepez: 5, cal_qa: 5, recomendaria: true, comentarios: '' },
  { nombre: 'Dra. Karla Murgueytio', especialidad: 'Gastroenterología', ciudad: 'Quito', sat_organizacion: 4, sat_escena: 5, sat_locacion: 4, sat_alimentacion: 3, cal_conferencia_ia: 5, cal_conferencia_yepez: 5, val_comunicacion_yepez: 5, cal_qa: 5, recomendaria: true, comentarios: '' },
  { nombre: 'Maribel Arévalo', especialidad: 'Medicina Interna', ciudad: 'Quito', sat_organizacion: 4, sat_escena: 4, sat_locacion: 4, sat_alimentacion: 4, cal_conferencia_ia: 5, cal_conferencia_yepez: 5, val_comunicacion_yepez: 5, cal_qa: 5, recomendaria: true, comentarios: 'Todo excelente' },
  { nombre: 'Steve Alexander Padilla Paredes', especialidad: 'Medicina General', ciudad: 'Quito', sat_organizacion: 4, sat_escena: 4, sat_locacion: 4, sat_alimentacion: 4, cal_conferencia_ia: 5, cal_conferencia_yepez: 5, val_comunicacion_yepez: 5, cal_qa: 5, recomendaria: true, comentarios: 'Me gusto mucho la presentacion donde se aclara tambien los puntos negativos del medicamento o riesgos q tiene' },
  { nombre: 'Juan Zuniga', especialidad: 'Gastroenterología', ciudad: 'Quito', sat_organizacion: 5, sat_escena: 5, sat_locacion: 5, sat_alimentacion: 5, cal_conferencia_ia: 5, cal_conferencia_yepez: 5, val_comunicacion_yepez: 5, cal_qa: 5, recomendaria: true, comentarios: '' },
  { nombre: 'Adnan Sayah', especialidad: 'Gastroenterología', ciudad: 'Quito', sat_organizacion: 5, sat_escena: 5, sat_locacion: 5, sat_alimentacion: 3, cal_conferencia_ia: 4, cal_conferencia_yepez: 4, val_comunicacion_yepez: 5, cal_qa: 3, recomendaria: true, comentarios: '' },
  { nombre: 'Dra. Karla Paulette Ruiz Conforme', especialidad: 'Gastroenterología', ciudad: 'Guayaquil', sat_organizacion: 4, sat_escena: 4, sat_locacion: 4, sat_alimentacion: 3, cal_conferencia_ia: 5, cal_conferencia_yepez: 5, val_comunicacion_yepez: 5, cal_qa: 5, recomendaria: true, comentarios: '' },
  { nombre: 'Cristina Zambrano Rosero', especialidad: 'Gastroenterología', ciudad: 'Quito', sat_organizacion: 5, sat_escena: 5, sat_locacion: 5, sat_alimentacion: 4, cal_conferencia_ia: 5, cal_conferencia_yepez: 5, val_comunicacion_yepez: 5, cal_qa: 5, recomendaria: true, comentarios: '' },
  { nombre: 'Dra. Soberanía Rengifo', especialidad: 'Gastroenterología', ciudad: 'Guayaquil', sat_organizacion: 5, sat_escena: 5, sat_locacion: 5, sat_alimentacion: 5, cal_conferencia_ia: 5, cal_conferencia_yepez: 5, val_comunicacion_yepez: 5, cal_qa: 5, recomendaria: true, comentarios: '' },
  { nombre: 'Dra. Andrea Jackeline Abad Armas', especialidad: 'Gastroenterología', ciudad: 'Quito', sat_organizacion: 4, sat_escena: 4, sat_locacion: 5, sat_alimentacion: 5, cal_conferencia_ia: 5, cal_conferencia_yepez: 5, val_comunicacion_yepez: 5, cal_qa: 5, recomendaria: true, comentarios: 'Puntualidad' },
  { nombre: 'Dr. Andrés Reyes', especialidad: 'Gastroenterología', ciudad: 'Quito', sat_organizacion: 4, sat_escena: 4, sat_locacion: 4, sat_alimentacion: 4, cal_conferencia_ia: 4, cal_conferencia_yepez: 4, val_comunicacion_yepez: 4, cal_qa: 4, recomendaria: true, comentarios: '' },
  { nombre: 'Ivan Alexander Ayabaca Povea', especialidad: 'Medicina Interna', ciudad: 'Quito', sat_organizacion: 4, sat_escena: 5, sat_locacion: 5, sat_alimentacion: 4, cal_conferencia_ia: 5, cal_conferencia_yepez: 5, val_comunicacion_yepez: 5, cal_qa: 5, recomendaria: true, comentarios: 'Todo bien' },
  { nombre: 'Dr. Rubén Muñoz Cedeño', especialidad: 'Gastroenterología', ciudad: 'Guayaquil', sat_organizacion: 4, sat_escena: 3, sat_locacion: 3, sat_alimentacion: 4, cal_conferencia_ia: 4, cal_conferencia_yepez: 4, val_comunicacion_yepez: 3, cal_qa: 3, recomendaria: true, comentarios: '' },
  { nombre: 'Ligia Elena Basantes', especialidad: 'Gastroenterología', ciudad: 'Quito', sat_organizacion: 4, sat_escena: 5, sat_locacion: 4, sat_alimentacion: 3, cal_conferencia_ia: 5, cal_conferencia_yepez: 5, val_comunicacion_yepez: 5, cal_qa: 5, recomendaria: true, comentarios: '' },
  { nombre: 'Dra. Emma Terranova Barrezueta', especialidad: 'Gastroenterología', ciudad: 'Guayaquil', sat_organizacion: 5, sat_escena: 5, sat_locacion: 5, sat_alimentacion: 5, cal_conferencia_ia: 5, cal_conferencia_yepez: 5, val_comunicacion_yepez: 5, cal_qa: 5, recomendaria: true, comentarios: 'Gracias. Felicitaciones' },
  { nombre: 'Dra. Marjorie Ordoñez', especialidad: 'Gastroenterología', ciudad: 'Quito', sat_organizacion: 4, sat_escena: 4, sat_locacion: 4, sat_alimentacion: 4, cal_conferencia_ia: 5, cal_conferencia_yepez: 5, val_comunicacion_yepez: 5, cal_qa: 4, recomendaria: true, comentarios: '' },
  { nombre: 'Fallon Tayo Roldan', especialidad: 'Gastroenterología', ciudad: 'Guayaquil', sat_organizacion: 4, sat_escena: 4, sat_locacion: 4, sat_alimentacion: 4, cal_conferencia_ia: 5, cal_conferencia_yepez: 5, val_comunicacion_yepez: 5, cal_qa: 5, recomendaria: true, comentarios: '' },
  { nombre: 'Dr. Luis Linzan Villavicencio', especialidad: 'Gastroenterología', ciudad: 'Portoviejo', sat_organizacion: 4, sat_escena: 4, sat_locacion: 5, sat_alimentacion: 4, cal_conferencia_ia: 5, cal_conferencia_yepez: 5, val_comunicacion_yepez: 5, cal_qa: 5, recomendaria: true, comentarios: '' },
  { nombre: 'Dr. Oswaldo Blanco', especialidad: 'Otro', ciudad: 'Guayaquil', sat_organizacion: 5, sat_escena: 5, sat_locacion: 5, sat_alimentacion: 5, cal_conferencia_ia: 5, cal_conferencia_yepez: 5, val_comunicacion_yepez: 5, cal_qa: 5, recomendaria: true, comentarios: 'Todo excelente' },
  { nombre: 'Viteri Vitri', especialidad: 'Gastroenterología', ciudad: 'Guayaquil', sat_organizacion: 4, sat_escena: 4, sat_locacion: 4, sat_alimentacion: 4, cal_conferencia_ia: 5, cal_conferencia_yepez: 5, val_comunicacion_yepez: 5, cal_qa: 5, recomendaria: true, comentarios: '' },
  { nombre: 'Fernando Xavier Vélez Ocampo', especialidad: 'Gastroenterología', ciudad: 'Guayaquil', sat_organizacion: 4, sat_escena: 4, sat_locacion: 5, sat_alimentacion: 4, cal_conferencia_ia: 5, cal_conferencia_yepez: 5, val_comunicacion_yepez: 5, cal_qa: 4, recomendaria: true, comentarios: 'Mejoraría la puntualidad' },
]

// ── Constantes ───────────────────────────────────────────────────────────────

const PURPLE = '#6a5cbc'
const PURPLE_LIGHT = '#6a5cbc18'
const SHADES = ['#6a5cbc', '#7d71c9', '#9186d6', '#a49be3', '#c4bef0']
const CIUDADES = ['todas', ...Array.from(new Set(ENCUESTAS.map((e) => e.ciudad))).sort()]

const CATEGORIAS = [
  { key: 'sat_organizacion' as keyof RespuestaEncuesta, label: 'Organización', grupo: 'org' },
  { key: 'sat_escena' as keyof RespuestaEncuesta, label: 'Puesta en escena', grupo: 'org' },
  { key: 'sat_locacion' as keyof RespuestaEncuesta, label: 'Locación', grupo: 'org' },
  { key: 'sat_alimentacion' as keyof RespuestaEncuesta, label: 'Alimentación', grupo: 'org' },
  { key: 'cal_conferencia_ia' as keyof RespuestaEncuesta, label: 'Conferencia IA', grupo: 'cient' },
  { key: 'cal_conferencia_yepez' as keyof RespuestaEncuesta, label: 'Dr. Yépez', grupo: 'cient' },
  { key: 'val_comunicacion_yepez' as keyof RespuestaEncuesta, label: 'Comunicación Yépez', grupo: 'cient' },
  { key: 'cal_qa' as keyof RespuestaEncuesta, label: 'Sesión Q&A', grupo: 'cient' },
]

// ── Helpers ──────────────────────────────────────────────────────────────────

function avgKey(data: RespuestaEncuesta[], key: keyof RespuestaEncuesta) {
  if (!data.length) return 0
  return +(data.reduce((s, e) => s + (e[key] as number), 0) / data.length).toFixed(2)
}

function ScoreBar({ value }: { value: number }) {
  const pct = (value / 5) * 100
  const color = value >= 4.5 ? '#2fbc80' : value >= 3.5 ? PURPLE : '#f6c23e'
  return (
    <div className="flex items-center gap-3">
      <div className="flex-1 h-2.5 rounded-full bg-gray-100 dark:bg-gray-800">
        <div className="h-2.5 rounded-full transition-all" style={{ width: `${pct}%`, backgroundColor: color }} />
      </div>
      <span className="text-sm font-bold w-8 text-right" style={{ color }}>{value}</span>
    </div>
  )
}

function KpiCard({ icon: Icon, label, value }: { icon: React.ElementType; label: string; value: string | number }) {
  return (
    <div
      className="rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-card px-4 py-4 flex flex-col gap-2"
      style={{ backgroundImage: `linear-gradient(to right, ${PURPLE_LIGHT}, transparent 60%)` }}
    >
      <p className="text-[11px] font-medium text-muted-foreground uppercase tracking-wide">{label}</p>
      <div className="flex items-center gap-3">
        <Icon className="h-8 w-8 shrink-0" style={{ color: PURPLE }} />
        <span className="text-3xl font-bold text-foreground">{value}</span>
      </div>
    </div>
  )
}

// ── Página ────────────────────────────────────────────────────────────────────

export function AdiumEncuestaPage() {
  useDocumentTitle('Encuesta Vozama')
  const navigate = useNavigate()
  const [filtroCiudad, setFiltroCiudad] = useState('todas')

  const data = useMemo(
    () => filtroCiudad === 'todas' ? ENCUESTAS : ENCUESTAS.filter((e) => e.ciudad === filtroCiudad),
    [filtroCiudad],
  )

  const promedioGeneral = useMemo(() => {
    if (!data.length) return 0
    const keys = CATEGORIAS.map((c) => c.key)
    const total = data.reduce((sum, e) => sum + keys.reduce((s, k) => s + (e[k] as number), 0), 0)
    return +(total / (data.length * keys.length)).toFixed(2)
  }, [data])

  const pctRecomendaria = data.length
    ? Math.round((data.filter((e) => e.recomendaria).length / data.length) * 100)
    : 0

  const barData = CATEGORIAS.map((c) => ({ label: c.label, value: avgKey(data, c.key), grupo: c.grupo }))
  const comentarios = data.filter((e) => e.comentarios.trim())

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 p-6 space-y-6">

      {/* Header */}
      <Card className="border border-gray-200 dark:border-gray-700">
        <CardContent className="py-4 px-6">
          <div className="flex items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <button
                onClick={() => navigate('/registros/adium')}
                className="flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors"
              >
                <ArrowLeft className="h-4 w-4" />
                Volver al reporte
              </button>
              <div className="h-4 w-px bg-gray-200 dark:bg-gray-700" />
              <div>
                <h1 className="text-xl font-bold text-foreground flex items-center gap-2">
                  <ClipboardList className="h-5 w-5" style={{ color: PURPLE }} />
                  Encuesta de satisfacción
                </h1>
                <p className="text-sm text-muted-foreground mt-0.5">Conferencia Científica VOZAMA® · Septiembre 2026</p>
              </div>
            </div>
            <img src="/logo-tonal-negro.png" alt="Tonal" className="h-10 w-auto dark:invert" />
          </div>
        </CardContent>
      </Card>

      {/* Filtro ciudad */}
      <div className="flex gap-2 flex-wrap items-center">
        <MapPin className="h-4 w-4 text-muted-foreground" />
        {CIUDADES.map((c) => (
          <button
            key={c}
            onClick={() => setFiltroCiudad(c)}
            className="px-3 py-1.5 rounded-md text-xs font-medium transition-colors"
            style={
              filtroCiudad === c
                ? { backgroundColor: PURPLE, color: '#fff' }
                : { backgroundColor: `${PURPLE}14`, color: PURPLE }
            }
          >
            {c === 'todas' ? 'Todas las ciudades' : c}
          </button>
        ))}
        <span className="text-xs text-muted-foreground ml-2">{data.length} respuesta{data.length !== 1 ? 's' : ''}</span>
      </div>

      {data.length === 0 ? (
        <Card className="border border-gray-200 dark:border-gray-700">
          <CardContent className="py-12 text-center text-muted-foreground text-sm">
            No hay respuestas para esta ciudad aún.
          </CardContent>
        </Card>
      ) : (
        <>
          {/* KPIs */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <KpiCard icon={ClipboardList} label="Respuestas" value={data.length} />
            <KpiCard icon={Star} label="Promedio general" value={`${promedioGeneral} / 5`} />
            <KpiCard icon={ThumbsUp} label="Recomendarían" value={`${pctRecomendaria}%`} />
          </div>

          {/* Gráfica de promedios */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            {/* Organización */}
            <Card className="border border-gray-200 dark:border-gray-700">
              <CardHeader className="pb-2">
                <CardTitle className="text-sm font-semibold text-muted-foreground uppercase tracking-wide">Organización del evento</CardTitle>
              </CardHeader>
              <CardContent className="flex flex-col gap-4">
                {CATEGORIAS.filter((c) => c.grupo === 'org').map((c) => (
                  <div key={c.key}>
                    <p className="text-xs text-muted-foreground mb-1">{c.label}</p>
                    <ScoreBar value={avgKey(data, c.key)} />
                  </div>
                ))}
              </CardContent>
            </Card>

            {/* Contenido científico */}
            <Card className="border border-gray-200 dark:border-gray-700">
              <CardHeader className="pb-2">
                <CardTitle className="text-sm font-semibold text-muted-foreground uppercase tracking-wide">Contenido científico</CardTitle>
              </CardHeader>
              <CardContent className="flex flex-col gap-4">
                {CATEGORIAS.filter((c) => c.grupo === 'cient').map((c) => (
                  <div key={c.key}>
                    <p className="text-xs text-muted-foreground mb-1">{c.label}</p>
                    <ScoreBar value={avgKey(data, c.key)} />
                  </div>
                ))}
              </CardContent>
            </Card>
          </div>

          {/* Gráfica de barras comparativa */}
          <Card className="border border-gray-200 dark:border-gray-700">
            <CardHeader className="pb-2">
              <CardTitle className="text-sm font-semibold text-muted-foreground uppercase tracking-wide">Comparativa por categoría</CardTitle>
            </CardHeader>
            <CardContent>
              <ResponsiveContainer width="100%" height={280}>
                <BarChart data={barData} layout="vertical" margin={{ left: 0, right: 50, top: 4, bottom: 4 }}>
                  <XAxis type="number" domain={[0, 5]} hide />
                  <YAxis dataKey="label" type="category" width={180} tickLine={false} axisLine={false} tick={{ fontSize: 11 }} interval={0} />
                  <Tooltip formatter={(v: number) => [`${v} / 5`, 'Promedio']} contentStyle={{ fontSize: 12, borderRadius: 8 }} />
                  <Bar dataKey="value" radius={[0, 4, 4, 0]}>
                    {barData.map((_, i) => <Cell key={i} fill={SHADES[i % SHADES.length]} />)}
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </CardContent>
          </Card>

          {/* Comentarios */}
          {comentarios.length > 0 && (
            <Card className="border border-gray-200 dark:border-gray-700">
              <CardHeader className="pb-2">
                <CardTitle className="text-sm font-semibold text-muted-foreground uppercase tracking-wide">Comentarios</CardTitle>
              </CardHeader>
              <CardContent className="flex flex-col gap-3">
                {comentarios.map((e, i) => (
                  <div key={i} className="rounded-lg p-3 text-sm" style={{ backgroundColor: PURPLE_LIGHT }}>
                    <p className="text-foreground">{e.comentarios}</p>
                    <p className="text-xs text-muted-foreground mt-1">— {e.nombre} · {e.especialidad} · {e.ciudad}</p>
                  </div>
                ))}
              </CardContent>
            </Card>
          )}

          {/* Tabla detalle */}
          <Card className="border border-gray-200 dark:border-gray-700">
            <CardHeader className="pb-2">
              <CardTitle className="text-sm font-semibold text-muted-foreground uppercase tracking-wide">Detalle de respuestas</CardTitle>
            </CardHeader>
            <CardContent className="p-0">
              <div className="overflow-x-auto">
                <table className="w-full text-xs">
                  <thead>
                    <tr className="border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/50">
                      {['Nombre', 'Especialidad', 'Ciudad', 'Org.', 'Escena', 'Locación', 'Aliment.', 'IA', 'Yépez', 'Comun.', 'Q&A', 'Recom.'].map((h) => (
                        <th key={h} className="text-left px-3 py-2 font-semibold text-muted-foreground uppercase tracking-wide whitespace-nowrap">{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((e, i) => {
                      const scores = [e.sat_organizacion, e.sat_escena, e.sat_locacion, e.sat_alimentacion, e.cal_conferencia_ia, e.cal_conferencia_yepez, e.val_comunicacion_yepez, e.cal_qa]
                      return (
                        <tr key={i} className="border-b border-gray-100 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-900/30">
                          <td className="px-3 py-2 font-medium text-foreground whitespace-nowrap">{e.nombre}</td>
                          <td className="px-3 py-2 text-muted-foreground whitespace-nowrap">{e.especialidad}</td>
                          <td className="px-3 py-2 text-muted-foreground whitespace-nowrap">{e.ciudad}</td>
                          {scores.map((v, j) => (
                            <td key={j} className="px-3 py-2 text-center font-semibold" style={{ color: v >= 4 ? '#2fbc80' : v === 3 ? '#f6c23e' : '#eb6587' }}>{v}</td>
                          ))}
                          <td className="px-3 py-2 text-center">{e.recomendaria ? <span style={{ color: '#2fbc80' }}>✓</span> : <span style={{ color: '#eb6587' }}>✗</span>}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            </CardContent>
          </Card>
        </>
      )}

      <p className="text-center text-xs text-muted-foreground/40 pb-2">
        Tonal Strategies · Septiembre 2026 · Adium Vonoprazan
      </p>
    </div>
  )
}
